<template>
    <standard-layout v-if="invoice" header="Bestellung stornieren / teilstornieren">
        <template v-slot:main>
            <p class="d-none border border-secondary text-secondary text-sm p-2">
                Wenn eine Umbuchung auf ein Erlebnis ohne Fahrt erfolgt, ist das
                ein Teil-Storno.<br/>
                Sollte das Erlebnis komplett ausfallen, wird es als ganzes storniert.<br/>
                Es wird eine neue Rechnung erstellt, die dieser Bestellung zugeordnet ist und die
                dann den negativen Storno-Betrag enthält, so dass alles auch für die Steuer stimmt.
                Die eigentliche Rückzahlung muss dann noch manuell oin PayPal vorgenommen werden oder
                in bar erfolgen. Sobald das passiert ist, setzt man die Rechnung, die hier entsteht, auf "bezahlt".
            </p>
            <table class="table mt-3">
                <tr>
                    <td>Bestellung</td>
                    <td>
                        <router-link :to="{name: 'orderDetail', params: {id: invoice.order.id}}">{{
                            invoice.order.number
                            }}
                        </router-link>
                    </td>
                </tr>
                <tr>
                    <td>vom</td>
                    <td>{{ invoice.order.createdTime | date }}</td>
                </tr>
                <tr>
                    <td>Kunde</td>
                    <td>
                        <router-link :to="{name: 'customerDetail', params: {id: invoice.order.customer.id}}">
                            {{ invoice.order.customer.name }}
                        </router-link>
                    </td>
                </tr>
                <tr>
                    <td>bezahlt</td>
                    <td>{{ invoice.amount | price }}</td>
                </tr>
                <tr v-if="invoice.order.reservation">
                    <td>Reservierung</td>
                    <td>
                        <router-link :to="{name: 'reservationDetail', params: {id: invoice.order.reservation.number}}">
                            {{ invoice.order.reservation.number }}
                        </router-link>
                        {{ invoice.order.reservation.startTime | dateTime }}
                    </td>
                </tr>
                <tr>
                    <td>Rechnungen</td>
                    <td>
                        <router-link v-for="invoice in relatedInvoices" :key="invoice.id"
                                     :to="{name: 'invoiceDetail', params: {id: invoice.id}}">
                            {{ invoice.amount | price }}
                            <invoice-state-badge :invoice="invoice" class="ml-2"/>
                        </router-link>
                    </td>
                </tr>
            </table>
            <div class="card mt-3">
                <div class="card-header">
                    Storno
                </div>
                <div class="card-body">
                    <label for="#canceledAmountInput" class="col-form-label">Erstattungsbetrag (€)</label>
                    <input id="canceledAmountInput" class="form-control form-text" v-model="creditedAmount"/>
                    <label for="#descriptionInput" class="col-form-label">Beschreibung</label>
                    <input id="descriptionInput" placeholder="z.B. Umbuchung auf Erlebnis ohne Fahrt"
                           class="form-control form-text" v-model="description"/>
                    <div class="mt-2 text-right">
                        <button class="btn btn-primary" @click="creditOnInvoice">Betrag erstatten</button>
                    </div>
                </div>
            </div>
            <div v-if="false" class="bg-info p-2 mt-3">
                <p>
                    <b>Komplette Stornierung:</b><br/>
                    Sollte ein Gutschein verwendet worden sein, wird der Gutschein wieder aktiviert.
                    Sollte der Gutschein nur einen Teil des Bestellwertes
                    abdecken, wird zusätzlich der Restbetrag noch an den Gast ausgezahlt.
                </p>
                <p>
                    <b class="mt-1">Teil-Storno</b><br/>
                    <i>Nur möglich bei bereits gezahlten Rechnungen.</i><br/>
                    Der Storno-Betrag wird zuerst von einem verwendeten Gutschein genommen.<br/>
                    Gutscheinwert höher als Storno-Betrag: Es wird ein neuer Wertgutschein erstellt, der den Reest
                    enthält.<br/>
                    Gutscheinwert kleiner als Storno-Betrag: Der Restbetrag muss noch an den Gast gezahlt werden.
                </p>
            </div>
        </template>
    </standard-layout>
</template>
<script>
import StandardLayout from "@/layouts/StandardLayout";
import InvoiceStateBadge from "../components/invoice/InvoiceStateBadge.vue";

export default {
    props: {
        invoiceId: String
    },
    data() {
        return {
            invoice: null,
            relatedInvoices: [],
            creditedAmount: 0,
            description: null
        }
    },
    methods: {
        async init() {
            this.invoice = await this.$api.get(`/invoices/${this.invoiceId}`)
                .then(res => res.data)
            this.creditedAmount = this.invoice.amount
            this.$api.get("/invoices/related", {params: {order: this.invoice.order.id}})
                .then(res => this.relatedInvoices = res.data)
                .catch(err => this.handleError(err))
        },
        async creditOnInvoice() {
            const request = {
                invoiceId: this.invoice.id,
                amount: this.creditedAmount,
                description: this.description
            }
            await this.$api.post(`/invoices/${this.invoice.id}`, request)
                .then(res => this.$router.push({name: 'invoiceDetail', params: {id: res.data.id}}))
                .catch(err => this.handleError(err))
        }
    },
    created() {
        this.init()
    },
    components: {
        InvoiceStateBadge,
        StandardLayout
    }
}
</script>

